import { render, staticRenderFns } from "./Sympla.vue?vue&type=template&id=f739bca6"
import script from "./Sympla.vue?vue&type=script&lang=js"
export * from "./Sympla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports